import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 22,
	height: 17,
	viewBox: "0 0 22 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.05058 17L4.6772 16.8544L0.17321 12.7358C-0.0473453 12.5335 -0.0589544 12.195 0.148058 11.9775C0.355071 11.7619 0.701384 11.7506 0.923875 11.9548L5.04092 15.7198L21.0641 0.155066C21.2788 -0.0529437 21.6271 -0.0510516 21.8399 0.156958C22.0547 0.368749 22.0527 0.707195 21.838 0.917095L5.43946 16.845L5.05058 17Z",
		fill: "#272525"
	})
});
export { SvgCheck as ReactComponent };
